import { useEffect, useState } from "react";
import { fetchPokemon } from "../services/pokemonService";

function usePokemonDetails(pokemonRef, options = {}) {
  const { enabled = true } = options;
  const [pokemon, setPokemon] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    let isMounted = true;

    async function loadPokemon() {
      if (!enabled || !pokemonRef) {
        setPokemon(null);
        setLoading(false);
        setError(null);
        return;
      }

      setLoading(true);
      setError(null);

      try {
        const pokemonData = await fetchPokemon(pokemonRef);
        if (isMounted) {
          setPokemon(pokemonData);
        }
      } catch (requestError) {
        if (isMounted) {
          setPokemon(null);
          setError(requestError);
        }
      } finally {
        if (isMounted) {
          setLoading(false);
        }
      }
    }

    loadPokemon();

    return () => {
      isMounted = false;
    };
  }, [pokemonRef, enabled]);

  return { pokemon, loading, error };
}

export default usePokemonDetails;
